import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API()+'klienci/plik/';

export default {

    deletePlik(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/PlikiService.js